import { useState } from 'react';
import ServiceSelector from './ServiceSelector';
import DateTimeSelector from './DateTimeSelector';
import ReservationSummary from './ReservationSummary';
import UserInformationForm from './UserInformationForm';

const AppointmentPage = () => {
  const [step, setStep] = useState(1);
  const [appointmentData, setAppointmentData] = useState({
    service: '',
    location: '',
    advisor: '',
    date: '',
    timeSlot: '',
    price: 100,
    name: '',
    email: '',
    phone: '',
    note: '',
    termsAccepted: false,
  });

  const handleNextStep = (data: Partial<typeof appointmentData>) => {
    setAppointmentData((prev) => ({ ...prev, ...data }));
    setStep((prev) => prev + 1);
  };

  const handlePrevStep = () => setStep((prev) => prev - 1);
  const handleEdit = () => setStep(1);

  const handleReserve = (data: {
    name: string;
    email: string;
    phone: string;
    note: string;
    termsAccepted: boolean;
  }) => {
    setAppointmentData((prev) => ({ ...prev, ...data }));
    console.log('Reservation submitted:', { ...appointmentData, ...data });
  };

  return (
    <>
      <section className="appointment_heros">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="main-title">
                <h2>Book an Appointment </h2>
                <p>Trust. Expertise. Results.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="container py-5 pb-3">
        {step === 1 && (
          <ServiceSelector
            value={appointmentData}
            onNext={(data) => handleNextStep(data)}
          />
        )}

        {step === 2 && (
          <DateTimeSelector
            value={appointmentData}
            onNext={(data) => handleNextStep(data)}
            onBack={handlePrevStep}
          />
        )}

        {step === 3 && (
          <ReservationSummary
            service={appointmentData.service}
            date={appointmentData.date}
            timeSlot={appointmentData.timeSlot}
            location={appointmentData.location}
            advisor={appointmentData.advisor}
            price={appointmentData.price}
            onEdit={handleEdit}
            onNext={() => setStep(4)}
          />
        )}

        {step === 4 && (
          <UserInformationForm
            appointmentData={appointmentData}
            onBack={handlePrevStep}
            onReserve={handleReserve}
          />
        )}
      </div>
    </>
  );
};

export default AppointmentPage;
